import { ActionBrick, registerBrick, BrickContext } from 'olympe';

export default class DispatchOnSelectedItem extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} selectedItem
     * @param {*} functionSignature
     * @param {function()} forwardEvent
     */
    update($, [selectedItem, functionSignature], [forwardEvent]) {
        if (!functionSignature) {
            // nothing to dispatch
            return;
        }
        const [triggerInput, selItemInput] = functionSignature.getInputs();
        const funcSign$ = $.runner(functionSignature);
        funcSign$.set(selItemInput, selectedItem);
        funcSign$.trigger(triggerInput);
        // TODO: should destroy ?
        forwardEvent();
    }
}

registerBrick('01934485ff43a70614a2', DispatchOnSelectedItem);
